import { DEGREE_OUTPUT_LABEL } from '@/helpers/unit-formatter/shared/constants';
import { FormattedUnitLabels, NumericFormatterInput } from '@/helpers/unit-formatter/shared/types';
import { degreesToWindDirection, normalizeDegrees } from '@/helpers/unit-formatter/shared/utils';

/**
 * Formatter for wind direction display values.
 * - `valueLabel`: degrees rounded to the nearest integer and normalized into [0, 360).
 * - `unitsLabel` cardinal: derived via `degreesToWindDirection` 8-point compass mapping.
 *
 * Non-numeric passthrough is handled by `asPassthroughNonNumericFormatter` at registry build.
 */
export const formatDirection = ({ value }: NumericFormatterInput): FormattedUnitLabels => {
  const normalized = normalizeDegrees(value);
  const cardinal = degreesToWindDirection(normalized);
  const unitsLabel = `${DEGREE_OUTPUT_LABEL} ${cardinal}`;

  const valueLabel = `${normalized}`;

  const valueUnitsLabel = `${normalized}${unitsLabel}`;

  return {
    valueLabel,
    unitsLabel,
    prefixedValueLabel: valueLabel,
    unitSuffixLabel: unitsLabel,
    suffixedValueLabel: valueUnitsLabel,
    valueUnitsLabel,
  };
};
